import { Link } from "react-router-dom";
import type { Movie } from "@/types/movie";

export default function EditorialPicks({ movies }: { movies: Movie[] }) {
  return (
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
      {movies.map((movie) => (
        <article
          key={movie.id}
          className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
        >
          <Link to={`/detail/${movie.id}`} className="block">
            <div className="relative aspect-[16/10] w-full overflow-hidden bg-background-200">
              <img
                src={movie.backdrop}
                alt={`${movie.title} 剧照`}
                title={`${movie.title} - 秋霞电影`}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-background-50/95 px-2 py-1 text-xs font-semibold text-accent-700">
                <span className="w-3 h-3 flex items-center justify-center"><i className="ri-star-fill"></i></span>
                {movie.rating.toFixed(1)}
              </span>
            </div>
          </Link>
          <div className="flex flex-1 flex-col p-4">
            <div className="flex items-center gap-2 text-xs text-foreground-500">
              <span className="rounded bg-secondary-100 px-2 py-0.5 text-secondary-800">{movie.genres[0]}</span>
              <span>{movie.year}</span>
            </div>
            <h3 className="mt-2.5 text-base font-semibold text-foreground-950">
              <Link to={`/detail/${movie.id}`} className="hover:text-primary-700 transition-colors">{movie.title}</Link>
            </h3>
            <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">
              {movie.tagline}
            </p>
            <div className="mt-3 flex flex-wrap gap-1.5">
              {movie.tags.slice(0, 2).map((t) => (
                <span key={t} className="rounded bg-accent-100 px-2 py-0.5 text-xs text-accent-900">{t}</span>
              ))}
            </div>
          </div>
        </article>
      ))}
    </div>
  );
}